
import { commonInputAttrs } from './shared'
import useTracking from '~/composable/tracking/useTracking';

export default {
  props: {
    label: {
      type: String,
      default: 'SIM-kort nummer'
    }
  },
  setup() {
    const { trackFieldRule, trackFieldError } = useTracking()
    return {
      trackFieldError,
      commonInputAttrs,
      fieldRules: [
        v => !!v || trackFieldRule({ message: 'Du skal indtaste et sim nummer', fieldName: 'sim' }),
        v => /^\+?[0-9\s]/.test(v) || trackFieldRule({ message: 'SIM-kortnummeret du har indtastet er ikke gyldigt. Prøv venligst igen.' })
      ]
    }
  }
}
